module.exports = __webpack_public_path__ + "static/Apercu-Bold-545982804ce5479a41918259c5ad7138.svg";